import React, { useEffect, ReactNode } from "react"

import { useHowdyGames } from "./Game"

import initializeContext from "./actions/initializeContext"
import isProduction from "@hfc/shared/utils/isProduction"

const logArtwork = () => {
	if (isProduction()) {
		console.info(`
		__    __   ______   __       __  _______   __      __ 
		/  |  /  | /      \\ /  |  _  /  |/       \\ /  \\    /  |
		$$ |  $$ |/$$$$$$  |$$ | / \\ $$ |$$$$$$$  |$$  \\  /$$/ 
		$$ |__$$ |$$ |  $$ |$$ |/$  \\$$ |$$ |  $$ | $$  \\/$$/  
		$$    $$ |$$ |  $$ |$$ /$$$  $$ |$$ |  $$ |  $$  $$/   
		$$$$$$$$ |$$ |  $$ |$$ $$/$$ $$ |$$ |  $$ |   $$$$/    
		$$ |  $$ |$$ \\__$$ |$$$$/  $$$$ |$$ |__$$ |    $$ |    
		$$ |  $$ |$$    $$/ $$$/    $$$ |$$    $$/     $$ |    
		$$/   $$/  $$$$$$/  $$/      $$/ $$$$$$$/      $$/  
		`)
		console.info(`Build ${process.env.NEXT_PUBLIC_BUILD_ID}`)
	}
}
interface GameControllerProps {
	children?: ReactNode
}

const GameController = ({ children = null }: GameControllerProps) => {
	const game = useHowdyGames()

	useEffect(() => {
		if (!game.isInitialized) {
			logArtwork()
			initializeContext(game)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [game.isInitialized])

	useEffect(() => {
		// check for web3 provider, ask to connect if previously connected/approved
	}, [])

	useEffect(() => {
		// detect account change
	}, [])

	useEffect(() => {
		// detect (blockchain) network change
	}, [])

	useEffect(() => {
		// detect cellular network change
	}, [])

	return <>{children}</>
}

export default GameController
